export default __webpack_public_path__ + "21440ddd23ead68a74b24c84f9f71233.jpg";